'use client';

import { Tabs as BaseTabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useState } from 'react';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';

export function Tabs(props) {
  const { list = [], children, defaultValue, onChange, onHover, value } = props;

  if (!list.length) return <></>;

  return (
    <BaseTabs value={value} defaultValue={defaultValue} onValueChange={onChange}>
      <ScrollArea>
        <TabsList className='flex gap-10 justify-center sm:gap-20 border-b border-b-primary overflow-clip min-h-fit'>
          {list.map((item, index) => (
            <TabsTrigger
              value={item.value}
              key={`tab-${index}`}
              onMouseEnter={() => {
                if (!onHover) return;
                onHover(item?.value);
              }}
            >
              {item.label}
            </TabsTrigger>
          ))}
        </TabsList>
        <ScrollBar orientation='horizontal' classNames={{ thumb: 'rounded-none bg-background/10' }} />
      </ScrollArea>
      {children}
    </BaseTabs>
  );
}
